export function safeRender(val: any): string {
  if (val === null || val === undefined) return '-';
  return typeof val === 'object' ? JSON.stringify(val) : String(val);
}
